import { useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { CustomNavigationClient } from "./NavigationClient";

///////////////////////////
// New azure authorization methodology
import { MsalProvider } from "@azure/msal-react";
//import { loginRequest } from "./authConfig"
//import withAuthProvider from "./components/services/authProvider";
///////////////////////////

import { loginRequest } from "./authConfig.js";

import ProtectedRoute from "./components/common/protectedRoute";
import Navbar from "./components/common/Navbar";
import { ToastContainer } from "react-toastify";
import Home from "./components/Home";
import Calendar from "./components/Calendar";
import MyCaseload from "./components/MyCaseload";
import UnsignedEncounters from "./components/UnsignedEncounters";
import UnsignedProgramEncounters from "./components/UnsignedProgramEncounters";
import "./App.css";
import "./styles/base/custom.css";
import "react-toastify/dist/ReactToastify.css";
import RevPayors from "./components/rev/RevPayors";
import RevPayor from "./components/rev/RevPayor";
import { Services, Service } from "./components/rev/Services.jsx";
import ServiceConfig from "./components/rev/ServiceConfig.jsx";
import ServiceStatuses from "./components/admin/ServiceStatuses";
import CensusRulesEngine from "./components/CensusRulesEngine";
import ClientCensusRules from "./components/rev/ClientCensusRules.jsx";
import CensusRules from "./components/rev/CensusRules.jsx";
import CensusRule from "./components/rev/CensusRule.jsx";
import Homes from "./components/homes/Homes";
import ResidenceFosterHomes from "./components/residences/ResidenceFosterHomes.jsx";
import ResidenceFosterHome from "./components/residences/ResidenceFosterHome.jsx";
import ResidenceProgramHomes from "./components/residences/ResidenceProgramHomes.jsx";
import ResidenceProgramHome from "./components/residences/ResidenceProgramHome.jsx";
import DailyServices from "./components/rev/DailyServices.jsx";
import ClientDailyServices from "./components/rev/ClientDailyServices.jsx";
import Apartments from "./components/apartments/Apartments";
import Apartment from "./components/apartments/Apartment";
import CrisisReferral from "./components/mobileCrisis/CrisisReferral";
import CrisisReferrals from "./components/mobileCrisis/CrisisReferrals";

import Admin from "./components/Admin";
import ErrorLogs from "./components/common/ErrorLogs";
import Compare from "./components/pipeline/Compare";
import AIM from "./components/admin/AIM";
import AllCaseloads from "./components/AllCaseloads";
import Approvals from "./components/Approvals";
import BedDayStatuses from "./components/BedDayStatuses";
import BulkCaseNotes from "./components/BulkCaseNotes";
import CallHistory from "./components/CallHistory";
import Changelog from "./components/Changelog";
import Client2 from "./components/Client2";
import Contact from "./components/Contact";
import NonClient from "./components/NonClient.jsx";
import FastTimeEntry from "./components/supervision/FastTimeEntry";
import FosterHomes from "./components/FosterHomes";
import FosterHome from "./components/FosterHome";
import SAFYHomes from "./components/SAFYHomes";
import Intake from "./components/Intake";
import OnCall from "./components/OnCall";
import Referral from "./components/Referral";
import Reports from "./components/Reports";
import Share from "./components/Share";
import SoarCorrespondenceForm from "./components/SOARCorrespondenceForm";
import DocusignSuccess from "./components/forms/DocusignSuccess";

import GroupSupervisionLog from "./components/supervision/GroupSupervisionLog";
import IndividualSupervisionLog from "./components/supervision/IndividualSupervisionLog";
import Supervision from "./components/supervision/Supervision";
import Supervision2 from "./components/supervision/Supervision2";
import Individual from "./components/supervision/Individual";
import Group from "./components/supervision/Group";

import Formsy from "./components/assessments/Formsy";

import FormsTracking from "./components/forms/FormsTracking";

import ALCANS from "./components/assessments/ALCANS";
import ALCovid from "./components/assessments/ALCovid";
import ALHandbookAcknowledgement from "./components/assessments/ALHandbookAcknowledgement";
import ALIIHSF157 from "./components/assessments/ALIIHSF157";
import ALIIHSF157v2 from "./components/assessments/ALIIHSF157v2";
import ALIIHSHandbookAcknowledgement from "./components/assessments/ALIIHSHandbookAcknowledgement";
import ALILF167 from "./components/assessments/ALILF167";
import ALILPSafetyChecklist from "./components/assessments/ALILPSafetyChecklist";
import ALIR from "./components/assessments/ALIR";
import ALIRv2 from "./components/assessments/ALIRv2";
import ALMHConsent from "./components/assessments/ALMHConsent";
import ALMonthlyReport from "./components/assessments/ALMonthlyReport";
import ALMonthlyReportv2 from "./components/assessments/ALMonthlyReportv2";
import ALMonthlyReportv3 from "./components/assessments/ALMonthlyReportv3";
import ALPSD from "./components/assessments/ALPSD";
import ALReleaseOfInformation from "./components/assessments/ALReleaseOfInformation";
import ALReleaseOfInformationMP from "./components/assessments/ALReleaseOfInformationMP";
import ALTFCCAPRCA from "./components/assessments/ALTFCCAPRCA";
import ALTFCCAPRecommendation from "./components/assessments/ALTFCCAPRecommendation";
import ALTFCCAPReport from "./components/assessments/ALTFCCAPReport";
import ALTFCCAPRequestForHold from "./components/assessments/ALTFCCAPRequestForHold";
import ALTFCCarePlanSignature from "./components/assessments/ALTFCCarePlanSignature";
import ALTFCLivingSkills from "./components/assessments/ALTFCLivingSkills";
import ALTFTCParentCoaching from "./components/assessments/ALTFTCParentCoaching";
import ALTFCRecipientCareAgreement from "./components/assessments/ALTFCRecipientCareAgreement";
import ALTFCSemiAnnual from "./components/assessments/ALTFCSemiAnnual";
import ALTFCSemiAnnualv2 from "./components/assessments/ALTFCSemiAnnualv2";
import ALWeeklyReport from "./components/reports/ALWeeklyReport";

import COBSFTSessionLog from "./components/assessments/COBSFTSessionLog";
import COBSFTSessionLogv2 from "./components/assessments/COBSFTSessionLogv2";
import COCANS from "./components/assessments/COCANS";
import COCANSv2 from "./components/assessments/COCANSv2";
import COConsent from "./components/assessments/COConsent";
import COCRSP from "./components/assessments/COCRSP";
import CODischargeSummary from "./components/assessments/CODischargeSummary";
import CODischargeNotice from "./components/assessments/CODischargeNotice";
import COFPProviderCommunication from "./components/assessments/COFPProviderCommunication";
import COIntakeSymptoms from "./components/assessments/COIntakeSymptoms";
import COIntakeSymptomsv2 from "./components/assessments/COIntakeSymptomsv2";
import COMC18Assessment from "./components/assessments/COMC18Assessment";
import COMCActivity from "./components/assessments/COMCActivity";
import COMCAssessment from "./components/assessments/COMCAssessment";
import COMCF027M from "./components/assessments/COMCF027M";
import COMCF027Mv2 from "./components/assessments/COMCF027Mv2";
import COMCOutcome from "./components/assessments/COMCOutcome";
import COMCSafetyPlan from "./components/assessments/COMCSafetyPlan";
import COMCRRespiteFollowUp from "./components/assessments/COMCRRespiteFollowUp";
import COMonthlyReport from "./components/assessments/COMonthlyReport";
import COMonthlyUpdate from "./components/assessments/COMonthlyUpdate";
import COPSD from "./components/assessments/COPSD";
import COPSDv2 from "./components/assessments/COPSDv2";
import COReleaseOfInformation from "./components/assessments/ReleaseOfInformation";
import COReleaseOfInformationMP from "./components/assessments/ReleaseOfInformationMP";
import CORSCA from "./components/assessments/CORSCA";
import COTFCDischargeSummaryv2 from "./components/assessments/COTFCDischargeSummaryv2";
import COTFCPlacementSheet from "./components/assessments/COTFCPlacementSheet";
import COTFCPSD from "./components/assessments/COTFCPSD";
import COTFCPSDv2 from "./components/assessments/COTFCPSDv2";
import COTFTCParentCoaching from "./components/assessments/COTFTCParentCoaching";

import KY1293 from "./components/assessments/KY1293";
import KY1294A from "./components/assessments/KY1294A";
import KY1294B from "./components/assessments/KY1294B";
import KY1294Bv2 from "./components/assessments/KY1294Bv2";
import KYALP from "./components/assessments/KYALP";
import KYALPv2 from "./components/assessments/KYALPv2";
import KYF176 from "./components/assessments/KYF176";
import KYF216 from "./components/assessments/KYF216";
import KYF277 from "./components/assessments/KYF277";
import KYHFDischargeSummary from "./components/assessments/KYHFDischargeSummary";
import KYHFFamilyStory from "./components/assessments/KYHFFamilyStory";
import KYHFPlanOfCare from "./components/assessments/KYHFPlanOfCare";
import KYHFPlanOfCarev2 from "./components/assessments/KYHFPlanOfCarev2";
import KYHFPlanOfCarev3 from "./components/assessments/KYHFPlanOfCarev3";
import KYHFPlanOfCarev4 from "./components/assessments/KYHFPlanOfCarev4";
import KYHFPSD from "./components/assessments/KYHFPSD";
import KYHFPSDv2 from "./components/assessments/KYHFPSDv2";
import KYHFScreener from "./components/assessments/KYHFScreener";
import KYHFWeeklyUpdate from "./components/assessments/KYHFWeeklyUpdate";
import KYHTSA from "./components/assessments/KYHTSA";
import KYILF179YIL from "./components/assessments/KYILF179YIL";
import KYILPSD from "./components/assessments/KYILPSD";
import KYILSkillsChecklist from "./components/assessments/KYILSkillsChecklist";
import KYJAHMonthlyReport from "./components/assessments/KYJAHMonthlyReport";
import KYJAHPSE from "./components/assessments/KYJAHPSE";
import KYJAHVisitSummary from "./components/assessments/KYJAHVisitSummary";
import KYPCCPCPDischargeSummary from "./components/assessments/KYPCCPCPDischargeSummary";
import KYPCCPCPDischargeSummaryv2 from "./components/assessments/KYPCCPCPDischargeSummaryv2";
import KYTFCADOS from "./components/assessments/KYTFCADOS";
import KYTFCF032 from "./components/assessments/KYTFCF032.jsx";
import KYTFCFirstPlacement from "./components/assessments/KYTFCFirstPlacement";
import KYTFCFirstPlacementv2 from "./components/assessments/KYTFCFirstPlacementv2";
import KYTFCPSD from "./components/assessments/KYTFCPSD";
import KYTFCPSDv2 from "./components/assessments/KYTFCPSDv2";

import INAdultNotice from "./components/assessments/INAdultNotice";
import INBSFTSessionLog from "./components/assessments/INBSFTSessionLog";
import INCBSMonthlyReport from "./components/assessments/INCBSMonthlyReport";
import INCBSPSD from "./components/assessments/INCBSPSD";
import INClosureNotice from "./components/assessments/INClosureNotice";
import INEFF063 from "./components/assessments/INEFF063";
import INEFMonthlyReport from "./components/assessments/INEFMonthlyReport";
import INEFPSD from "./components/assessments/INEFPSD";
import INEFPSDv2 from "./components/assessments/INEFPSDv2";
import INEFPSDv3 from "./components/assessments/INEFPSDv3";
import INIFCDischargeSummary from "./components/assessments/INIFCDischargeSummary";
import INIFCMonthlyReport from "./components/assessments/INIFCMonthlyReport";
import INIFCRespiteLog from "./components/assessments/INIFCRespiteLog";
import INKSPMonthlyv3 from "./components/assessments/INKSPMonthlyv3";
import INKSPPSD from "./components/assessments/INKSPPSD";
import INOPPSE from "./components/assessments/INOPPSE";
import INParentingTasksChecklist from "./components/assessments/INParentingTasksChecklist";
import INTFCF232 from "./components/assessments/INTFCF232";
import INTFCMonthlyReport from "./components/assessments/INTFCMonthlyReport";
import INTFCMonthlyReportv2 from "./components/assessments/INTFCMonthlyReportv2";
import INTFCPlacementChecklist from "./components/assessments/INTFCPlacementChecklist";
import INTFCPSE from "./components/assessments/INTFCPSE";
import INTFTCParentCoaching from "./components/assessments/INTFTCParentCoaching";
import INYouthNotice from "./components/assessments/INYouthNotice";

import NVBHCNAdultNotice from "./components/assessments/NVBHCNAdultNotice";
import NVBHCNDischargeNotice from "./components/assessments/NVBHCNDischargeNotice";
import NVBHCNMonthlyReport from "./components/assessments/NVBHCNMonthlyReport";
import NVBHCNYouthNotice from "./components/assessments/NVBHCNYouthNotice";
import NVCMHA from "./components/assessments/NVCMHA";
import NVPPMConsent from "./components/assessments/NVPPMConsent";
import NVReleaseOfInformation from "./components/assessments/NVReleaseOfInformation";
import NVSafetyPlan from "./components/assessments/NVSafetyPlan";
import NVTFCCaseTransfer from "./components/assessments/NVTFCCaseTransfer";
import NVTFCCaseTransferv2 from "./components/assessments/NVTFCCaseTransferv2";
import NVTFCCASII from "./components/assessments/NVTFCCASII";
import NVTFCCFT from "./components/assessments/NVTFCCFT";
import NVTFCCFTv2 from "./components/assessments/NVTFCCFTv2";
import NVTFCCOS from "./components/assessments/NVTFCCOS";
import NVTFCCrisisNotice from "./components/assessments/NVTFCCrisisNotice";
import NVTFCIR from "./components/assessments/NVTFCIR";
import NVTFCIRv2 from "./components/assessments/NVTFCIRv2";
import NVTFCIRv3 from "./components/assessments/NVTFCIRv3";
import NVTFCTTMScheduling from "./components/assessments/NVTFCTTMScheduling";
import NVTFCYouthNotice from "./components/assessments/NVTFCYouthNotice";
import NVTFTCParentCoaching from "./components/assessments/NVTFTCParentCoaching";
import NVTransitionv2 from "./components/assessments/NVTransitionv2";
import NVVOCAReport from "./components/assessments/NVVOCAReport";

import OHBridgesIR from "./components/assessments/OHBridgesIR";
import OHCFFSROI from "./components/assessments/OHCFFSROI";
import OHDICF483 from "./components/assessments/OHDICF483";
import OHDICF525 from "./components/assessments/OHDICF525";
import OHDICIntake from "./components/assessments/OHDICIntake";
import OHEFMonthlyReport from "./components/assessments/OHEFMonthlyReport";
import OHEFPSD from "./components/assessments/OHEFPSD";
import OHEFROI from "./components/assessments/OHEFROI";
import OHEFWeeklyProgress from "./components/assessments/OHEFWeeklyProgress";
import OHF019 from "./components/assessments/OHF019";
import OHF102 from "./components/assessments/OHF102";
import OHF487IL from "./components/assessments/OHF487IL";
import OHFPCrisisChecklist from "./components/assessments/OHFPCrisisChecklist";
import OHFranklinIR from "./components/assessments/OHFranklinIR";
import OHFranklinIRv2 from "./components/assessments/OHFranklinIRv2";
import OHIFSCompliance from "./components/assessments/OHIFSCompliance";
import OHIHBTSafetyPlan from "./components/assessments/OHIHBTSafetyPlan";
import OHLBHAdult30Day from "./components/assessments/OHLBHAdult30Day";
import OHLBHAdult30Dayv2 from "./components/assessments/OHLBHAdult30Dayv2";
import OHLBHAdultNotice from "./components/assessments/OHLBHAdultNotice";
import OHLBHCSBProgress from "./components/assessments/OHLBHCSBProgress";
import OHLBHDischargeNotice from "./components/assessments/OHLBHDischargeNotice";
import OHLBHMMS from "./components/assessments/OHLBHMMS";
import OHLBHTPILetter from "./components/assessments/OHLBHTPILetter";
import OHLBHYouth30Day from "./components/assessments/OHLBHYouth30Day";
import OHLBHYouth30Dayv2 from "./components/assessments/OHLBHYouth30Dayv2";
import OHLBHYouthNotice from "./components/assessments/OHLBHYouthNotice";
import OHNOR from "./components/assessments/OHNOR";
import OHROI from "./components/assessments/OHROI";
import OHPPMonthlyReport from "./components/assessments/OHPPMonthlyReport";
import OHPPMonthlyReportv2 from "./components/assessments/OHPPMonthlyReportv2";
import OHPPMonthlyReportv3 from "./components/assessments/OHPPMonthlyReportv3";
import OHPPMonthlyReportv4 from "./components/assessments/OHPPMonthlyReportv4";
import OHPPOutcome from "./components/assessments/OHPPOutcome";
import OHPPSelfEntry from "./components/assessments/OHPPSelfEntry";
import OHPPSelfExit from "./components/assessments/OHPPSelfExit";
import OHParentPartnerReport from "./components/reports/OHParentPartnerReport";
import OHPSD from "./components/assessments/OHPSD";
import OHPSDv2 from "./components/assessments/OHPSDv2";
import OHSafetyPlan from "./components/assessments/OHSafetyPlan";
import OHStatutoryRape from "./components/assessments/OHStatutoryRape";
import OHTFCDischargeSummary from "./components/assessments/OHTFCDischargeSummary";
import OHTFCF021 from "./components/assessments/OHTFCF021";
import OHTFCF039 from "./components/assessments/OHTFCF039";
import OHTFCF084 from "./components/assessments/OHTFCF084";
import OHTFCMonthlyProgressReport from "./components/assessments/OHTFCMonthlyProgressReport";
import OHTFCMonthlyProgressReportv2 from "./components/assessments/OHTFCMonthlyProgressReportv2";
import OHTFCMonthlyProgressReportv3 from "./components/assessments/OHTFCMonthlyProgressReportv3";
import OHTFCMonthlyVisitationCuyahoga from "./components/assessments/OHTFCMonthlyVisitationCuyahoga";
import OHTFCMonthlyVisitationCuyahogav2 from "./components/assessments/OHTFCMonthlyVisitationCuyahogav2";
import OHTFCMonthlyVisitationMarion from "./components/assessments/OHTFCMonthlyVisitationMarion";
import OHTFCMonthlyVisitationMarionv2 from "./components/assessments/OHTFCMonthlyVisitationMarionv2";
import OHTFCSORCDischarge from "./components/assessments/OHTFCSORCDischarge";
import OHTFCSORCMCPMonthlyProgressReport from "./components/assessments/OHTFCSORCMCPMonthlyProgressReport";
import OHTFCSORCMonthlyProgressReport from "./components/assessments/OHTFCSORCMonthlyProgressReport";
import OHTFCSORCNonMCPMonthlyProgressReport from "./components/assessments/OHTFCSORCNonMCPMonthlyProgressReport";
import OHTFCPSD from "./components/assessments/OHTFCPSD";
import OHWWKCaseFileReview from "./components/assessments/OHWWKCaseFileReview";
import OHWWKIAR from "./components/assessments/OHWWKIAR";
import OHWWKQAR from "./components/assessments/OHWWKQAR";

import SCFRCPSDischargeSummary from "./components/assessments/SCFRCPSDischargeSummary";
import SCFRCPSDischargeSummaryv2 from "./components/assessments/SCFRCPSDischargeSummaryv2";
import SCFRCPSFamilyServicePlan from "./components/assessments/SCFRCPSFamilyServicePlan";
import SCFRCPSFamilyServicePlanv2 from "./components/assessments/SCFRCPSFamilyServicePlanv2";
import SCFRCPSFamilyServicePlanv3 from "./components/assessments/SCFRCPSFamilyServicePlanv3";
import SCFRCPSFASTAssessment from "./components/assessments/SCFRCPSFASTAssessment";
import SCFRCPSMonthlyProgressSummary from "./components/assessments/SCFRCPSMonthlyProgressSummary";
import SCFRCPSMonthlyUpload from "./components/assessments/SCFRCPSMonthlyUpload";
import SCMonthlyOutcomesv4 from "./components/assessments/SCMonthlyOutcomesv4";
import SCPPOutcome from "./components/assessments/SCPPOutcome";
import SCPPSelfEntry from "./components/assessments/SCPPSelfEntry";
import SCPPSelfExit from "./components/assessments/SCPPSelfExit";
import SCPPWeeklyReport from "./components/assessments/SCPPWeeklyReport";
import SCTFCDiagnostic from "./components/assessments/SCTFCDiagnostic";
import SCTFCDischargeCarePlan from "./components/assessments/SCTFCDischargeCarePlan";
import SCTFCF374 from "./components/assessments/SCTFCF374";
import SCTFCFollowUp from "./components/assessments/SCTFCFollowUp";
import SCTFCIR from "./components/assessments/SCTFCIR";
import SCTFCIRv2 from "./components/assessments/SCTFCIRv2";
import SCTFCIRv3 from "./components/assessments/SCTFCIRv3";
import SCTFCOutcomes from "./components/assessments/SCTFCOutcomes";
import SCTFCTraditionalFCAssessment from "./components/assessments/SCTFCTraditionalFCAssessment";

import CinciEFDischargeSummary from "./components/assessments/CinciEFDischargeSummary";
import BirmIIHSWeeklyReport from "./components/assessments/BirmIIHSWeeklyReport";

import SAFYAdultSafetyPlan from "./components/assessments/SAFYAdultSafetyPlan";
import SAFYAdultSafetyPlanv2 from "./components/assessments/SAFYAdultSafetyPlanv2";
import SAFYAdultSafetyPlanv3 from "./components/assessments/SAFYAdultSafetyPlanv3";
import SAFYCaseyLifeSkills from "./components/assessments/SAFYCaseyLifeSkills";
import SAFYCATS from "./components/assessments/SAFYCATS";
import SAFYCRAFFT from "./components/assessments/SAFYCRAFFT";
import SAFYFAIR from "./components/assessments/SAFYFAIR";
import SAFYFPIncidentReport from "./components/assessments/SAFYFPIncidentReport";
import SAFYFPIncidentReportv2 from "./components/assessments/SAFYFPIncidentReportv2";
import SAFYGAD7 from "./components/assessments/SAFYGAD7";
import SAFYGAD7v2 from "./components/assessments/SAFYGAD7v2";
import SAFYILIncidentReport from "./components/assessments/SAFYILIncidentReport";
import SAFYILIncidentReportv2 from "./components/assessments/SAFYILIncidentReportv2";
import SAFYNCFAS from "./components/assessments/SAFYNCFAS";
import SAFYOPIncidentReport from "./components/assessments/SAFYOPIncidentReport";
import SAFYOPIncidentReportv2 from "./components/assessments/SAFYOPIncidentReportv2";
import SAFYPFS2Assessment from "./components/assessments/SAFYPFS2Assessment";
import SAFYPHQ9 from "./components/assessments/SAFYPHQ9";
import SAFYPHQ9v2 from "./components/assessments/SAFYPHQ9v2";
import SAFYRDIAssessment from "./components/assessments/SAFYRDIAssessment";
import SAFYSafetyPlan from "./components/assessments/SAFYSafetyPlan";
import SAFYSafetyPlanv2 from "./components/assessments/SAFYSafetyPlanv2";
import SAFYSafetyPlanv3 from "./components/assessments/SAFYSafetyPlanv3";
import SAFYTFCIncidentReport from "./components/assessments/SAFYTFCIncidentReport";
import SAFYTFCIncidentReportv2 from "./components/assessments/SAFYTFCIncidentReportv2";
import SAFYTFCIncidentReportv3 from "./components/assessments/SAFYTFCIncidentReportv3";
import SAFYTFCOutcomeMeasurements from "./components/assessments/SAFYTFCOutcomeMeasurements";
import SAFYURICA from "./components/assessments/SAFYURICA";
import SAFYURICAv2 from "./components/assessments/SAFYURICAv2";

import BulkCaseNote from "./components/assessments/BulkCaseNote";
import BulkCaseNotev2 from "./components/assessments/BulkCaseNotev2";
import CSSRsScreener from "./components/assessments/CSSRsScreener";
import DeveloperChangeRequest from "./components/assessments/DeveloperChangeRequest";
import DeveloperChangeRequestv2 from "./components/assessments/DeveloperChangeRequestv2";
import SAFYFPPortalCMS from "./components/assessments/SAFYFPPortalCMS";
import SystemChangeRequest from "./components/assessments/SystemChangeRequest";
import SystemChangeRequestv2 from "./components/assessments/SystemChangeRequestv2";
import VOCAReport from "./components/assessments/VOCAReport";
import VOCAReportv2 from "./components/assessments/VOCAReportv2";
import RCInvoice from "./components/RCInvoice";
import Requests from "./components/Requests";
import SAFYTFCOutcomes from "./components/assessments/SAFYTFCOutcomes";
import LoginHistory from "./components/common/LoginHistory";
import FHRulesInvestigation from "./components/assessment2/FHRulesInvestigation.jsx";
import FHPIP from "./components/assessment2/FHPIP.jsx";

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the route's navigate functions when MSAL redirects between pages in your app
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);
  const [token] = useState(pca.getActiveAccount()?.idTokenClaims);
  const renewToken = async () => {
    try {
      // const newToken = await pca.loginPopup();
      // setToken(newToken.idTokenClaims);
      // loadContainersVersions();
      pca
        .acquireTokenSilent({
          ...loginRequest,
          account: pca.getActiveAccount(),
        })
        .catch((e) => {
          pca.loginRedirect(loginRequest);
        });
    } catch (err) {
      console.log(err);
    }
  };

  // const loadContainersVersions = async () => {
  //   const allForms = await getFormContainersAndVersions();
  //   localStorage.setItem("formContainersVersions", JSON.stringify(allForms));
  //   console.log("AppJS - Setting Forms and Containters");
  // };

  // const [viewportWidth, setViewportWidth] = useState(
  //   Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
  // );

  // useEffect(() => {
  //   const getViewportWidth = () => {
  //     setViewportWidth(
  //       Math.max(
  //         document.documentElement.clientWidth || 0,
  //         window.innerWidth || 0
  //       )
  //     );
  //   };

  //   window.addEventListener("resize", getViewportWidth, true);
  //   return () => window.removeEventListener("resize", getViewportWidth);
  // }, []);

  return (
    <>
      <MsalProvider instance={pca}>
        <ToastContainer style={{ marginTop: "80px" }} theme="colored" />
        <Navbar
          //get access token from msal
          token={token}
          renewToken={renewToken}
          safyInfo={
            localStorage.getItem("safyInfo")
              ? JSON.parse(localStorage.getItem("safyInfo"))
              : {}
          }
        />
        <main id="main" className="container">
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin getAccessToken={pca.getAccessToken} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/logins"
              element={
                <ProtectedRoute>
                  <LoginHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/errors"
              element={
                <ProtectedRoute>
                  <ErrorLogs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/binticompare"
              element={
                <ProtectedRoute>
                  <Compare />
                </ProtectedRoute>
              }
            />
            <Route
              path="/aim"
              element={
                <ProtectedRoute>
                  <AIM />
                </ProtectedRoute>
              }
            />
            <Route
              path="/allcaseloads"
              element={
                <ProtectedRoute>
                  <AllCaseloads />
                </ProtectedRoute>
              }
            />
            <Route
              path="/approvals"
              element={
                <ProtectedRoute>
                  <Approvals />
                </ProtectedRoute>
              }
            />
            <Route
              path="/BDS"
              element={
                <ProtectedRoute>
                  <BedDayStatuses />
                </ProtectedRoute>
              }
            />
            <Route path="/BulkCaseNote/:formid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <BulkCaseNote />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <BulkCaseNote />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/BulkCaseNotev2/:formid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <BulkCaseNotev2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <BulkCaseNotev2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/BulkCaseNotes"
              element={
                <ProtectedRoute>
                  <BulkCaseNotes />
                </ProtectedRoute>
              }
            />
            <Route path="/calendar" element={<Calendar />} />
            <Route
              path="/callhistory/:divisionId"
              element={
                <ProtectedRoute>
                  <CallHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/changelog"
              element={
                <ProtectedRoute>
                  <Changelog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/client/:clientId"
              element={
                <ProtectedRoute>
                  <Client2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/nonclient/:contactId"
              element={
                <ProtectedRoute>
                  <NonClient />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contact/:contactID"
              element={
                <ProtectedRoute>
                  <Contact />
                </ProtectedRoute>
              }
            />
            <Route path="/correspondence">
              <Route
                path=":id"
                element={
                  <ProtectedRoute>
                    <SoarCorrespondenceForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SoarCorrespondenceForm />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/dssuccess" element={<DocusignSuccess />} />
            <Route path="/FastTimeEntry">
              <Route
                path=":entryid"
                element={
                  <ProtectedRoute>
                    <FastTimeEntry />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <FastTimeEntry />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/form/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <Formsy />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <Formsy />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/tracking"
              element={
                <ProtectedRoute>
                  <FormsTracking />
                </ProtectedRoute>
              }
            />
            <Route path="/fosterhomes">
              <Route path=":fosterhomeid">
                <Route
                  path="rules/:submissionid?"
                  element={
                    <ProtectedRoute>
                      <FHRulesInvestigation />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="pip/:submissionid?"
                  element={
                    <ProtectedRoute>
                      <FHPIP />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path=""
                  element={
                    <ProtectedRoute>
                      <FosterHome />
                    </ProtectedRoute>
                  }
                />
              </Route>
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <FosterHomes />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/homes/homes"
              element={
                <ProtectedRoute>
                  <Homes />
                </ProtectedRoute>
              }
            ></Route>
            <Route path="/residence/fosterhomes">
              <Route
                path=":id"
                element={
                  <ProtectedRoute>
                    <ResidenceFosterHome />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ResidenceFosterHomes />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/residence/programs">
              <Route
                path=":program/:id"
                element={
                  <ProtectedRoute>
                    <ResidenceProgramHome />
                  </ProtectedRoute>
                }
              />
              <Route
                path=":program"
                element={
                  <ProtectedRoute>
                    <ResidenceProgramHomes />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/apartments">
              <Route
                path=":id"
                element={
                  <ProtectedRoute>
                    <Apartment />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <Apartments />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/groupsupervision/:supervisionLogId"
              element={
                <ProtectedRoute>
                  <GroupSupervisionLog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/individualsupervision/:supervisionLogId"
              element={
                <ProtectedRoute>
                  <IndividualSupervisionLog />
                </ProtectedRoute>
              }
            />
            <Route path="/crisis">
              <Route
                path=":id"
                element={
                  <ProtectedRoute>
                    <CrisisReferral />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <CrisisReferrals />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/intake"
              element={
                <ProtectedRoute>
                  <Intake />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mycaseload"
              element={
                <ProtectedRoute>
                  <MyCaseload />
                </ProtectedRoute>
              }
            />
            <Route
              path="/oncall"
              element={
                <ProtectedRoute>
                  <OnCall />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pipeline"
              element={
                <ProtectedRoute>
                  <SAFYHomes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/referral/:referralID"
              element={
                <ProtectedRoute>
                  <Referral />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/ALWeeklyReport"
              element={
                <ProtectedRoute>
                  <ALWeeklyReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/requests"
              element={
                <ProtectedRoute>
                  <Requests />
                </ProtectedRoute>
              }
            />
            <Route path="/share/*" element={<Share />} />
            <Route
              path="/supervision"
              element={
                <ProtectedRoute>
                  <Supervision />
                </ProtectedRoute>
              }
            />
            <Route
              path="/supervision2"
              element={
                <ProtectedRoute>
                  <Supervision2 />
                </ProtectedRoute>
              }
            />
            483
            <Route
              path="/supervision/individual/:supervisionLogId"
              element={
                <ProtectedRoute>
                  <Individual />
                </ProtectedRoute>
              }
            />
            <Route
              path="/supervision/group/:supervisionLogId"
              element={
                <ProtectedRoute>
                  <Group />
                </ProtectedRoute>
              }
            />
            <Route
              path="/unsignedencounters"
              element={
                <ProtectedRoute>
                  <UnsignedEncounters />
                </ProtectedRoute>
              }
            />
            <Route
              path="/unsignedprogramencounters/:program"
              element={
                <ProtectedRoute>
                  <UnsignedProgramEncounters />
                </ProtectedRoute>
              }
            />
            <Route
              path="/CRE"
              element={
                <ProtectedRoute>
                  <CensusRulesEngine />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rev/rules"
              element={
                <ProtectedRoute>
                  <CensusRules />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rev/rules/:ruleId"
              element={
                <ProtectedRoute>
                  <CensusRule />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rev/client/rules"
              element={
                <ProtectedRoute>
                  <ClientCensusRules />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rev/census/services"
              element={
                <ProtectedRoute>
                  <DailyServices />
                </ProtectedRoute>
              }
            />
            <Route
              path="/client/services/:clientid/:residenceid/:bedid?"
              element={
                <ProtectedRoute>
                  <ClientDailyServices />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rev/payors"
              element={
                <ProtectedRoute>
                  <RevPayors />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rev/payor/:payorId"
              element={
                <ProtectedRoute>
                  <RevPayor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/servicestatuses"
              element={
                <ProtectedRoute>
                  <ServiceStatuses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/services"
              element={
                <ProtectedRoute>
                  <Services />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rev/services/:serviceId/:serviceConfigId"
              element={
                <ProtectedRoute>
                  <ServiceConfig />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rev/services/:serviceId"
              element={
                <ProtectedRoute>
                  <Service />
                </ProtectedRoute>
              }
            />
            <Route path="/COCANS/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COCANS />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COCANS />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/COCANSv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <COCANSv2 />
                </ProtectedRoute>
              }
            />
            <Route path="/CODischargeSummary/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <CODischargeSummary formType="TFC" />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <CODischargeSummary formType="TFC" />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COFPDischargeSummary/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <CODischargeSummary formType="FP" />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <CODischargeSummary formType="FP" />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COMCRDischargeSummary/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <CODischargeSummary formType="FP" />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <CODischargeSummary formType="FP" />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COTFCDischargeSummaryv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COTFCDischargeSummaryv2 formType="TFC" />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COTFCDischargeSummaryv2 formType="TFC" />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COTFCF502/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COTFCPlacementSheet />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COTFCPlacementSheet />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/CinciEFDischargeSummary/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <CinciEFDischargeSummary />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <CinciEFDischargeSummary />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/F-027/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COReleaseOfInformation />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COReleaseOfInformation />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/F-027M/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COReleaseOfInformationMP />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COReleaseOfInformationMP />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/CORSCA/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <CORSCA />
                </ProtectedRoute>
              }
            />
            <Route path="/COFPPCPCF/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COFPProviderCommunication />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COFPProviderCommunication />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/CO-TFC-F329/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COConsent formType="TFC" />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COConsent formType="TFC" />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COFPF329/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COConsent formType="FP" />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COConsent formType="FP" />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COTFTCParentCoaching/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COTFTCParentCoaching />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COTFTCParentCoaching />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/COPSD/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <COPSD />
                </ProtectedRoute>
              }
            />
            <Route
              path="/COPSDv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <COPSDv2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/COTFCPSD/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <COTFCPSD />
                </ProtectedRoute>
              }
            />
            <Route
              path="/COTFCPSDv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <COTFCPSDv2 />
                </ProtectedRoute>
              }
            />
            <Route path="/COCRSP/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COCRSP />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COCRSP />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COIntakeSymptoms/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COIntakeSymptoms />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COIntakeSymptoms />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COIntakeSymptomsv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COIntakeSymptomsv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COIntakeSymptomsv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COMonthlyReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COMonthlyReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COMonthlyReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COMonthlyUpdate/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COMonthlyUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COMonthlyUpdate />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/CODischargeNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <CODischargeNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <CODischargeNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COMC18Assessment/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COMC18Assessment />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COMC18Assessment />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COMCActivity/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COMCActivity />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COMCActivity />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COMCAssessment/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COMCAssessment />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COMCAssessment />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/COMCF027M/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <COMCF027M />
                </ProtectedRoute>
              }
            />
            <Route
              path="/COMCF027Mv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <COMCF027Mv2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/COMCOutcome/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <COMCOutcome />
                </ProtectedRoute>
              }
            />
            <Route path="/COMCSafetyPlan/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COMCSafetyPlan />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COMCSafetyPlan />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COMCRRespiteFollowUp/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COMCRRespiteFollowUp />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COMCRRespiteFollowUp />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COBSFTSessionLog/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COBSFTSessionLog />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COBSFTSessionLog />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/COBSFTSessionLogv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <COBSFTSessionLogv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <COBSFTSessionLogv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALTFCCAPRCA/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALTFCCAPRCA />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALTFCCAPRCA />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/ALTFCCAPRecommendation/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <ALTFCCAPRecommendation />
                </ProtectedRoute>
              }
            />
            <Route path="/ALTFCCAPReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALTFCCAPReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALTFCCAPReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/ALTFCCAPRequestForHold/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <ALTFCCAPRequestForHold />
                </ProtectedRoute>
              }
            />
            <Route path="/ALTFCCarePlanSignature/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALTFCCarePlanSignature />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALTFCCarePlanSignature />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALTFCF123/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALTFCLivingSkills />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALTFCLivingSkills />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALILPF122/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALILPSafetyChecklist />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALILPSafetyChecklist />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALIR/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALIR />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALIR />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALIRv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALIRv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALIRv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALF165/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALHandbookAcknowledgement />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALHandbookAcknowledgement />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALIIHSF004/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALIIHSHandbookAcknowledgement />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALIIHSHandbookAcknowledgement />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALTFCF076/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALTFCRecipientCareAgreement />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALTFCRecipientCareAgreement />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALMHConsent/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALMHConsent />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALMHConsent />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/ALMonthlyReport/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <ALMonthlyReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ALMonthlyReportv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <ALMonthlyReportv2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ALMonthlyReportv3/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <ALMonthlyReportv3 />
                </ProtectedRoute>
              }
            />
            <Route path="/ALF027/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALReleaseOfInformation />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALReleaseOfInformation />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALF027M/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALReleaseOfInformationMP />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALReleaseOfInformationMP />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALILF167/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALILF167 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALILF167 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALILF167/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALILF167 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALILF167 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/ALIIHSF157/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <ALIIHSF157 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ALIIHSF157v2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <ALIIHSF157v2 />
                </ProtectedRoute>
              }
            />
            <Route path="/ALTFTCParentCoaching/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALTFTCParentCoaching />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALTFTCParentCoaching />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALPSD/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALPSD />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALPSD />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALCANS/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALCANS />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALCANS />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALCovid/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALCovid />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALCovid />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALTFCSemiAnnual/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALTFCSemiAnnual />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALTFCSemiAnnual />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/ALTFCSemiAnnualv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <ALTFCSemiAnnualv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <ALTFCSemiAnnualv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/SAFYURICA/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SAFYURICA />
                </ProtectedRoute>
              }
            />
            <Route
              path="/SAFYURICAv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SAFYURICAv2 />
                </ProtectedRoute>
              }
            />
            <Route path="/BirmIIHSWeeklyReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <BirmIIHSWeeklyReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <BirmIIHSWeeklyReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVBHCNAdultNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVBHCNAdultNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVBHCNAdultNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/NVBHCNMonthlyReport/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <NVBHCNMonthlyReport />
                </ProtectedRoute>
              }
            />
            <Route path="/NVBHCNDischargeNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVBHCNDischargeNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVBHCNDischargeNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVBHCNYouthNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVBHCNYouthNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVBHCNYouthNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVCMHA/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVCMHA />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVCMHA />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVPPMC/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVPPMConsent />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVPPMConsent />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVROI/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVReleaseOfInformation />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVReleaseOfInformation />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVSafetyPlan/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVSafetyPlan />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVSafetyPlan />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCCaseTransfer/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCCaseTransfer />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCCaseTransfer />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCCaseTransferv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCCaseTransferv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCCaseTransferv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCCASII/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCCASII />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCCASII />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCCFT/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCCFT />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCCFT />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCCFTv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCCFTv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCCFTv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCCOS/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCCOS />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCCOS />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCCrisisNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCCrisisNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCCrisisNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCIR/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCIR />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCIR />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCIRv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCIRv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCIRv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCIRv3/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCIRv3 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCIRv3 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFTCParentCoaching/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFTCParentCoaching />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFTCParentCoaching />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCTTMScheduling/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCTTMScheduling />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCTTMScheduling />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTFCYouthNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTFCYouthNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTFCYouthNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVTransitionv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVTransitionv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVTransitionv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/NVVOCAReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <NVVOCAReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <NVVOCAReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHBridgesIR/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHBridgesIR />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHBridgesIR />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHCFFSF027/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHCFFSROI />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHCFFSROI />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHDICF483/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHDICF483 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHDICF483 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHDICF525/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHDICF525 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHDICF525 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHDICF094/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHDICIntake />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHDICIntake />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHEFMonthlyReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHEFMonthlyReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHEFMonthlyReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHEFPSD/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHEFPSD />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHEFPSD />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHEFROI/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHEFROI />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHEFROI />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHEFWeeklyProgress/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHEFWeeklyProgress />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHEFWeeklyProgress />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHF019/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHF019 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHF019 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHF102/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHF102 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHF102 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHF487IL/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHF487IL />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHF487IL />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHFPCrisisChecklist/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHFPCrisisChecklist />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHFPCrisisChecklist />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/OHFranklinIR/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHFranklinIR />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OHFranklinIRv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHFranklinIRv2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OHIFSCompliance/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHIFSCompliance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OHIHBTSafetyPlan/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHIHBTSafetyPlan />
                </ProtectedRoute>
              }
            />
            <Route path="/OHLBHAdult30Day/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHLBHAdult30Day />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHLBHAdult30Day />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHLBHAdult30Dayv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHLBHAdult30Dayv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHLBHAdult30Dayv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHLBHAdultNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHLBHAdultNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHLBHAdultNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHLBHCSBProgress/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHLBHCSBProgress />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHLBHCSBProgress />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHLBHDischargeNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHLBHDischargeNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHLBHDischargeNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHLBHMMS/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHLBHMMS />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHLBHMMS />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHLBHYouth30Day/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHLBHYouth30Day />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHLBHYouth30Day />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHLBHYouth30Dayv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHLBHYouth30Dayv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHLBHYouth30Dayv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHLBHYouthNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHLBHYouthNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHLBHYouthNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHLBHTPILetter/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHLBHTPILetter />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHLBHTPILetter />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHNOR/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHNOR />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHNOR />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/OHPPMonthlyReport/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHPPMonthlyReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OHPPMonthlyReportv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHPPMonthlyReportv2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OHPPMonthlyReportv3/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHPPMonthlyReportv3 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OHPPMonthlyReportv4/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHPPMonthlyReportv4 />
                </ProtectedRoute>
              }
            />
            <Route path="/OHPPOutcome/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHPPOutcome />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHPPOutcome />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHPPSelfEntry/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHPPSelfEntry />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHPPSelfEntry />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHPPSelfExit/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHPPSelfExit />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHPPSelfExit />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/OHParentPartnerReport"
              element={
                <ProtectedRoute>
                  <OHParentPartnerReport />
                </ProtectedRoute>
              }
            ></Route>
            <Route path="/OHPSD/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHPSD />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHPSD />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHPSDv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHPSDv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHPSDv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHROI/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHROI />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHROI />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHSafetyPlan/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHSafetyPlan />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHSafetyPlan />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCF021/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCF021 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCF021 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCF039/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCF039 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCF039 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCF084/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCF084 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCF084 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCDischargeSummary/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCDischargeSummary />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCDischargeSummary />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCMonthlyProgressReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyProgressReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyProgressReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCMonthlyProgressReportv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyProgressReportv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyProgressReportv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCMonthlyProgressReportv3/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyProgressReportv3 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyProgressReportv3 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCMonthlyVisitationCuyahoga/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyVisitationCuyahoga />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyVisitationCuyahoga />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCMonthlyVisitationCuyahogav2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyVisitationCuyahogav2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyVisitationCuyahogav2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCMonthlyVisitationMarion/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyVisitationMarion />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyVisitationMarion />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCMonthlyVisitationMarionv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyVisitationMarionv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCMonthlyVisitationMarionv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCSORCDischarge/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCSORCDischarge />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCSORCDischarge />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCSORCMCPMonthlyProgressReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCSORCMCPMonthlyProgressReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCSORCMCPMonthlyProgressReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCSORCMonthlyProgressReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCSORCMonthlyProgressReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCSORCMonthlyProgressReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/OHTFCSORCNonMCPMonthlyProgressReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHTFCSORCNonMCPMonthlyProgressReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHTFCSORCNonMCPMonthlyProgressReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/OHTFCPSD/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHTFCPSD />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OHWWKCaseFileReview/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHWWKCaseFileReview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OHWWKIAR/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHWWKIAR />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OHWWKQAR/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <OHWWKQAR />
                </ProtectedRoute>
              }
            />
            <Route path="/OHStatutoryRape/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <OHStatutoryRape />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <OHStatutoryRape />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KYF216/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYF216 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYF216 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KYF176/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYF176 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYF176 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/KYILF179YIL/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYILF179YIL />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYILPSD/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYILPSD />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYTFCPSD/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYTFCPSD />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYTFCPSDv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYTFCPSDv2 />
                </ProtectedRoute>
              }
            />
            <Route path="/KYTFCADOS/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYTFCADOS />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYTFCADOS />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/KYTFCF032/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYTFCF032 />
                </ProtectedRoute>
              }
            />
            <Route path="/KYTFCFirstPlacement/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYTFCFirstPlacement />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYTFCFirstPlacement />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KYTFCFirstPlacementv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYTFCFirstPlacementv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYTFCFirstPlacementv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KYF277/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYF277 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYF277 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/KYHFDischargeSummary/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYHFDischargeSummary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYHFFamilyStory/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYHFFamilyStory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYHFPlanOfCare/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYHFPlanOfCare />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYHFPlanOfCarev2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYHFPlanOfCarev2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYHFPlanOfCarev3/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYHFPlanOfCarev3 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYHFPlanOfCarev4/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYHFPlanOfCarev4 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYHFPSD/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYHFPSD />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYHFPSDv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYHFPSDv2 />
                </ProtectedRoute>
              }
            />
            <Route path="/KYHFScreener/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYHFScreener />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYHFScreener />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KYHFWeeklyUpdate/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYHFWeeklyUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYHFWeeklyUpdate />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KYILSkillsChecklist/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYILSkillsChecklist />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYILSkillsChecklist />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/KYJAHMonthlyReport/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYJAHMonthlyReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYJAHPSE/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYJAHPSE />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KYJAHVisitSummary/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <KYJAHVisitSummary />
                </ProtectedRoute>
              }
            />
            <Route path="/KYALP/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYALP />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYALP />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KYALPv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYALPv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYALPv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KY1293/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KY1293 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KY1293 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KY1294A/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KY1294A />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KY1294A />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KY1294B/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KY1294B />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KY1294B />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KY1294Bv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KY1294Bv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KY1294Bv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KYHTSA/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYHTSA />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYHTSA />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KYPCCPCPDischargeSummary/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYPCCPCPDischargeSummary />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYPCCPCPDischargeSummary />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/KYPCCPCPDischargeSummaryv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <KYPCCPCPDischargeSummaryv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <KYPCCPCPDischargeSummaryv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INAdultNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INAdultNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INAdultNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INBSFTSessionLog/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INBSFTSessionLog />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INBSFTSessionLog />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INCBSMonthlyReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INCBSMonthlyReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INCBSMonthlyReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INCBSPSD/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INCBSPSD />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INCBSPSD />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INClosureNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INClosureNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INClosureNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INEFF063/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INEFF063 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INEFF063 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INEFMonthlyReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INEFMonthlyReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INEFMonthlyReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INEFPSD/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INEFPSD />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INEFPSD />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INEFPSDv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INEFPSDv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INEFPSDv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INEFPSDv3/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INEFPSDv3 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INEFPSDv3 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INIFCDischargeSummary/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INIFCDischargeSummary />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INIFCDischargeSummary />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INIFCMonthlyReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INIFCMonthlyReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INIFCMonthlyReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INIFCRespiteLog/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INIFCRespiteLog />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INIFCRespiteLog />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INKSPMonthlyv3/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INKSPMonthlyv3 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INKSPMonthlyv3 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INKSPPSD/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INKSPPSD />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INKSPPSD />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INOPPSE/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INOPPSE />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INOPPSE />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INParentingTasksChecklist/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INParentingTasksChecklist />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INParentingTasksChecklist />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INTFCF232/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INTFCF232 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INTFCF232 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INTFCPSE/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INTFCPSE />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INTFCPSE />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INTFCMonthlyReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INTFCMonthlyReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INTFCMonthlyReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INTFCMonthlyReportv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INTFCMonthlyReportv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INTFCMonthlyReportv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INTFCPlacementChecklist/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INTFCPlacementChecklist />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INTFCPlacementChecklist />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INTFTCParentCoaching/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INTFTCParentCoaching />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INTFTCParentCoaching />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/INYouthNotice/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <INYouthNotice />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <INYouthNotice />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/SCPPOutcome/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SCPPOutcome />
                </ProtectedRoute>
              }
            />
            <Route
              path="/SCPPSelfEntry/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SCPPSelfEntry />
                </ProtectedRoute>
              }
            />
            <Route
              path="/SCPPSelfExit/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SCPPSelfExit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/SCPPWeeklyReport/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SCPPWeeklyReport />
                </ProtectedRoute>
              }
            />
            <Route path="/SCTFCDiagnostic/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCTFCDiagnostic />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCTFCDiagnostic />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SCTFCDischargeCarePlan/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCTFCDischargeCarePlan />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCTFCDischargeCarePlan />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/SCFRCPSDischargeSummary/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SCFRCPSDischargeSummary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/SCFRCPSDischargeSummaryv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SCFRCPSDischargeSummaryv2 />
                </ProtectedRoute>
              }
            />
            <Route path="/SCFRCPSFamilyServicePlan/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCFRCPSFamilyServicePlan />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCFRCPSFamilyServicePlan />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SCFRCPSFamilyServicePlanv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCFRCPSFamilyServicePlanv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCFRCPSFamilyServicePlanv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/SCFRCPSFamilyServicePlan/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SCFRCPSFamilyServicePlan />
                </ProtectedRoute>
              }
            />
            <Route
              path="/SCFRCPSFamilyServicePlanv2/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SCFRCPSFamilyServicePlanv2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/SCFRCPSFamilyServicePlanv3/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SCFRCPSFamilyServicePlanv3 />
                </ProtectedRoute>
              }
            />
            <Route path="/SCFRCPSFASTAssessment/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCFRCPSFASTAssessment />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCFRCPSFASTAssessment />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SCFRCPSMonthlyProgressSummary/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCFRCPSMonthlyProgressSummary />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCFRCPSMonthlyProgressSummary />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/SCFRCPSMonthlyUpload/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SCFRCPSMonthlyUpload />
                </ProtectedRoute>
              }
            />
            <Route path="/SCMonthlyOutcomesv4/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCMonthlyOutcomesv4 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCMonthlyOutcomesv4 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SCTFCF374/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCTFCF374 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCTFCF374 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SCTFCFollowUp/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCTFCFollowUp />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCTFCFollowUp />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SCTFCIR/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCTFCIR />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCTFCIR />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SCTFCIRv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCTFCIRv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCTFCIRv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SCTFCIRv3/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCTFCIRv3 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCTFCIRv3 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SCTFCOutcomes/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCTFCOutcomes />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCTFCOutcomes />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SCTFCTraditionalFCAssessment/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SCTFCTraditionalFCAssessment />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SCTFCTraditionalFCAssessment />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SafetyPlan/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYSafetyPlan />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYSafetyPlan />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SafetyPlanv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYSafetyPlanv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYSafetyPlanv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SafetyPlanv3/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYSafetyPlanv3 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYSafetyPlanv3 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/AdultSafetyPlan/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYAdultSafetyPlan />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYAdultSafetyPlan />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/AdultSafetyPlanv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYAdultSafetyPlanv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYAdultSafetyPlanv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/AdultSafetyPlanv3/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYAdultSafetyPlanv3 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYAdultSafetyPlanv3 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYCaseyLifeSkills/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYCaseyLifeSkills />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYCaseyLifeSkills />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYCATS/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYCATS />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYCATS />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYCRAFFT/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYCRAFFT />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYCRAFFT />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/SAFYFAIR/:formid/:clientid/:submissionid?"
              element={
                <ProtectedRoute>
                  <SAFYFAIR />
                </ProtectedRoute>
              }
            />
            <Route path="/SAFYGAD7/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYGAD7 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYGAD7 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYGAD7v2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYGAD7v2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYGAD7v2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYNCFAS/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYNCFAS />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYNCFAS />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYPFS2Assessment/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYPFS2Assessment />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYPFS2Assessment />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYPHQ9/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYPHQ9 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYPHQ9 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYPHQ9v2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYPHQ9v2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYPHQ9v2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYRDIAssessment/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYRDIAssessment />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYRDIAssessment />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYFPIR/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYFPIncidentReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYFPIncidentReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYFPIRv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYFPIncidentReportv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYFPIncidentReportv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYILIR/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYILIncidentReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYILIncidentReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYILIRv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYILIncidentReportv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYILIncidentReportv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYOPIR/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYOPIncidentReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYOPIncidentReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYOPIRv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYOPIncidentReportv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYOPIncidentReportv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYTFCIR/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYTFCIncidentReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYTFCIncidentReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYTFCIRv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYTFCIncidentReportv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYTFCIncidentReportv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYTFCIRv3/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYTFCIncidentReportv3 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYTFCIncidentReportv3 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYTFCOutcomeMeasurements/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYTFCOutcomeMeasurements />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYTFCOutcomeMeasurements />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYTFCOutcomes/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYTFCOutcomes />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYTFCOutcomes />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/CSSRsScreener/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <CSSRsScreener />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <CSSRsScreener />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/VOCAReport/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <VOCAReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <VOCAReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/VOCAReportv2/:formid/:clientid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <VOCAReportv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <VOCAReportv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/DeveloperChangeRequest/:formid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <DeveloperChangeRequest />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <DeveloperChangeRequest />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/DeveloperChangeRequestv2/:formid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <DeveloperChangeRequestv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <DeveloperChangeRequestv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SAFYFPPortalCMS/:formid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SAFYFPPortalCMS />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SAFYFPPortalCMS />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SystemChangeRequest/:formid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SystemChangeRequest />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SystemChangeRequest />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/SystemChangeRequestv2/:formid">
              <Route
                path=":submissionid"
                element={
                  <ProtectedRoute>
                    <SystemChangeRequestv2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <SystemChangeRequestv2 />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/RC/Invoice"
              element={
                <ProtectedRoute>
                  <RCInvoice />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
      </MsalProvider>
    </>
  );
}

export default App;
